import { FC, useState } from 'react';

import { closeModal } from '@/shared/lib';
import { Button, Input, ModalTemplate } from '@/shared/ui';
import { twMerge } from 'tailwind-merge';

const MAX_NAME_LENGTH = 64;

export const DocumentModal: FC<{
  doc: File;
  existingNames: string[];
  onSave: (customFileName: string) => void;
}> = ({ doc, existingNames, onSave }) => {
  const [name, setName] = useState<string>(doc.name || '');
  const [err, setErr] = useState<string>('');
  const normalizedExistingNames = existingNames.map((item) =>
    item.trim().toLowerCase(),
  );
  const handleSave = () => {
    const trimmedName = name.trim();
    if (!trimmedName) {
      setErr('Name cannot be empty');
      return;
    }
    if (trimmedName.length > MAX_NAME_LENGTH) {
      setErr('Max 64 symbols');
      return;
    }
    if (normalizedExistingNames.includes(trimmedName.toLowerCase())) {
      setErr('Name must be unique');
      return;
    }
    onSave(trimmedName);
    closeModal('doc-name-modal');
  };
  return (
    <ModalTemplate
      id="doc-name-modal"
      isHasCloseBtn
      title="What is this document?"
      className="p-1"
    >
      <Input
        value={name || undefined}
        onChange={(v) => {
          setErr('');
          setName(v?.target?.value);
        }}
        placeholder="Document name"
        variant="send"
        error={err}
        classNames={{
          wrapper: 'mt-3',
          description: twMerge([
            'text-base-100',
            !!err && 'text-negative-500',
          ]),
        }}
        description={err || 'Max 64 symbols'}
      />
      <Button
        variant="contrast-500"
        className="mb-1 mt-6"
        size="d-l"
        onClick={handleSave}
      >
        Save
      </Button>
    </ModalTemplate>
  );
};
